<template>
  <div class="home">
    <Room artistID='db' loadImmediate="true"/>
    <Loader/>
  </div>
</template>

<script>
// @ is an alias to /src
import Room from '@/components/Room';
import Loader from '@/components/Loader.vue';

export default {
  name: "DiedrickBrackens",
  components: {
    Room,
    Loader
  },

  data : function(){
    return {
      artist : 'db'
    }
  },

  computed : {
    selectedArtist : function() {
        return this.$store.state.panoartists.find(a => a.key == this.artist)
    },
    assets : function() {
      return [].concat(this.selectedArtist.pano).map(a => require(`@/assets/images/textures/${typeof a == 'string' ? a : a.src}`))
    }
  },

  methods : {
    
  },

  mounted() {
    console.log('DIEDRICK');

    this.$store.commit('setArtist', this.artist);
    this.$store.commit('load', {
        assets : this.assets,
        onComplete : () => {
          this.$store.commit('startRoom');
          this.$store.commit('setState', {name : 'room', state : 'load'});
        }
    });
  }
};
</script>
